<template>
  <w-autocomplete
    class='w-multiple-selection-filter'
    v-bind='filterProps($props, ["items"])'
    :items='sortedItems'
    hide-selected
    v-on='$listeners'
  >
    <template
      v-if='filterHasFilterOptions'
      #append
    >
      <MultipleSelectionFilterMenu
        :filter-options='filterOptions'
        :filter-option-text='filterOptionText'
        :option-select-disabled='optionSelectDisabled'
        @click:filterOption='handleFilterOption'
      />
    </template>
  </w-autocomplete>
</template>

<script>
import WorkAutocomplete from '@/components/global_components/forms/WorkAutocomplete';
import multipleSelectionMixin from "@/components/global_components/filters/multiple_selection_filter/shared/multiple-selection-mixin";
import { filterProps } from "@/utils/functional-component-utils";
import sortedItems from "@/mixins/component/sorted-items-mixin";

/**
 * @component WorkMultipleSelectionFilter
 * @description Multi-selection filter with popup menu based on `WorkAutocomplete`.
 * Allows selecting multiple values from a static list.
 * All `WorkAutocomplete` props are inherited.
 *
 * @emits {Array} input - Emitted when the selection changes.
 */
export default {
  name: 'WorkMultipleSelectionFilter',
  components: { MultipleSelectionFilterMenu: () =>
    import('@/components/global_components/filters/multiple_selection_filter/shared/MultipleSelectionFilterMenu')
  },
  mixins: [multipleSelectionMixin(WorkAutocomplete.props), sortedItems],
  methods: {
    filterProps: filterProps
  }
};
</script>
